import Map from "@commons/Map";
import PublicIcon from "@mui/icons-material/Public";
import Text from "@commons/Typography/Text";

type LastLocationMapProps = {
  latitude?: number | null;
  longitude?: number | null;
};

function LastLocationMap({ latitude, longitude }: LastLocationMapProps) {
  if (!latitude || !longitude) {
    return (
      <div className="w-full h-[40dvh] flex justify-center items-center text-gray-400 bg-gray-50 flex-col gap-2">
        <PublicIcon className="text-4xl" />
        <Text size="md">Localização não disponível</Text>
      </div>
    );
  }

  return (
    <div className="h-[40dvh] w-full">
      <Map.Localization longitude={longitude} latitude={latitude} />
    </div>
  );
}

export default LastLocationMap;
